export enum TaskType {
  REVIEW_PRICING = 'REVIEW_PRICING',
  APPROVE_SCENARIO = 'APPROVE_SCENARIO',
  OPPORTUNITY_ACTION_REQUIRED = 'OPPORTUNITY_ACTION_REQUIRED',
  OPPORTUNITY_APPROVAL = 'OPPORTUNITY_APPROVAL',
  SCHEDULED_REVIEW = 'SCHEDULED_REVIEW',
}

export enum TaskViewMode {
  RECEIVED_TASKS = 'RECEIVED_TASKS',
  DISTRIBUTED_TASKS = 'DISTRIBUTED_TASKS',
}

export enum TaskStatus {
  TODO = 'TODO',
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  DONE = 'DONE',
}

export enum LeadStatus {
  PENDING = 'PENDING',
  OVERDUE = 'OVERDUE',
  MEETING_PLANNED = 'MEETING_PLANNED',
  CALL_ME_BACK_PLANNED = 'CALL_ME_BACK_PLANNED',
  UNREACHABLE = 'UNREACHABLE',
  REJECTED = 'REJECTED',
  SUCCESS = 'SUCCESS',
}
